import logo from '../images/kilroy-name-logo-white.png';
import {
  MapPinIcon,
  UserIcon,
  ClockIcon,
  MapIcon,
  MagnifyingGlassIcon
} from '@heroicons/react/24/outline';
import {
  MapPinIcon as MapPinIconSolid,
  UserIcon as UserIconSolid,
  ClockIcon as ClockIconSolid,
  MapIcon as MapIconSolid,
  MagnifyingGlassIcon as MagnifyingGlassIconSolid
} from '@heroicons/react/24/solid';
import React, { useState, useEffect } from 'react';

const Header = (props) => {
  const [locName, setLocName] = useState();
  const [fetching, setFetching] = useState(false);

  const getMyLocationName = async (lat, lon) => {
    if (!fetching) {
      await setFetching(true);
      const data = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`);
      const d = await data.json();
      await setLocName(d.name || d.address?.suburb || d.address?.road);
      await setFetching(false);
    }
  };

  useEffect(() => {
    async function doInit() {
      if (props.coords) {
        await getMyLocationName(props.coords.latitude, props.coords.longitude);
      }
    }
    doInit();
  }, [props.coords]);

  const doShowMap = () => {
    props.setShowHistory(false);
    props.setShowSearch(false);
    props.setShowMy(false);
    props.mapState ? props.setShowMap(false) : props.setShowMap(true);
  };

  const doShowHistory = () => {
    props.setShowMap(false);
    props.setShowSearch(false);
    props.setShowMy(false);
    props.setShowHistory(true);
  };

  const doShowSearch = () => {
    props.setShowMap(false);
    props.setShowHistory(false);
    props.setShowMy(false);
    props.setShowSearch(true);
  };

  const doShowMy = () => {
    props.setShowMap(false);
    props.setShowHistory(false);
    props.setShowSearch(false);
    props.setShowMy(true);
  };

  const doHome = () => {
    props.doHome();
  };

  const isHome = () => {
    return (!props.showMap && !props.showHistory && !props.showMy && !props.showSearch && !props.showCamera );
  }

  const isStandalone = () => {
    return window.matchMedia('(display-mode: standalone)').matches || 
           window.navigator.standalone === true;
  };

  return (
     <div className='header' style={isStandalone() ? { top: '40px' } : {}}>
        <div className='header-top'>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img onClick={() => window.location.reload()} alt='' className='logo' src={logo} />
            <a
              href="https://apps.apple.com/us/app/geopapyrus/id6756841539"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: '10px',
                color: '#4CAF50',
                textDecoration: 'none',
                padding: '2px 6px',
                border: '1px solid #4CAF50',
                borderRadius: '4px',
                whiteSpace: 'nowrap',
                fontWeight: '500'
              }}
            >
              Kilroy AR
            </a>
          </div>
          { props.coords &&
            <div className='location-info'>
              <span className='location-name'>{locName}</span>
              <span className='coordinates'>
                {Math.round(props.coords.latitude * 10000) / 10000}, {Math.round(props.coords.longitude * 10000) / 10000}
              </span>
            </div>
          }
        </div>
        { !props.showCamera &&
        <div className='nav-buttons'>
          <button
            className={`nav-btn ${isHome() ? 'active' : ''}`}
            onClick={doHome}
            title="All Posts"
          >
            {isHome() ? <MapPinIconSolid className="nav-icon" /> : <MapPinIcon className="nav-icon" />}
          </button>

          <button
            className={`nav-btn ${props.showMy ? 'active' : ''}`}
            onClick={doShowMy}
            title="My Posts"
          >
            {props.showMy ? <UserIconSolid className="nav-icon" /> : <UserIcon className="nav-icon" />}
          </button>

          <button
            className={`nav-btn ${props.showHistory ? 'active' : ''}`}
            onClick={doShowHistory}
            title="History"
          >
            {props.showHistory ? <ClockIconSolid className="nav-icon" /> : <ClockIcon className="nav-icon" />}
          </button>

          <button
            className={`nav-btn ${props.showMap ? 'active' : ''}`}
            onClick={doShowMap}
            title="Map View"
          >
            {props.showMap ? <MapIconSolid className="nav-icon" /> : <MapIcon className="nav-icon" />}
          </button>

          <button
            className={`nav-btn ${props.showSearch ? 'active' : ''}`}
            onClick={doShowSearch}
            title="Search"
          >
            {props.showSearch ? <MagnifyingGlassIconSolid className="nav-icon" /> : <MagnifyingGlassIcon className="nav-icon" />}
          </button>
        </div>
       }
     </div>
  );
}

export default Header;
